import EmpresasService from '../../services/EmpresasService';

export const namespaced = true;

export const state = {
  progresoDescargaQr: null,
  totalDescargaQr: null,
  descargandoQr: false,
};

export const mutations = {
  SET_PROGRESO_DESCARGA_QR(state, progreso) {
    state.progresoDescargaQr = progreso;
  },
  SET_TOTAL_DESCARGA_QR(state, total) {
    state.totalDescargaQr = total;
  },
  SET_DESCARGANDO_QR(state, descargando) {
    state.descargandoQr = descargando;
  },
};

export const actions = {
  generarQr({commit}) {
    commit('SET_DESCARGANDO_QR', true);
    return EmpresasService.generarQr({
      downloadProgress(evt) {
        if (evt.lengthComputable) {
          commit('SET_PROGRESO_DESCARGA_QR', evt.loaded);
          commit('SET_TOTAL_DESCARGA_QR', evt.total);
        }
      },
    }).then(r => {
      const nombre = r.headers.get('content-disposition')
        .split(';')
        .find(cd => cd.includes('filename'))
        .split('=')[1]
        .split('"').join(''); // para quitar el caracter "
      commit('SET_PROGRESO_DESCARGA_QR', null);
      commit('SET_TOTAL_DESCARGA_QR', null);
      commit('SET_DESCARGANDO_QR', false);
      return r.blob().then(b => ({
        blob: b,
        nombre
      }));
    }).catch((e) => {
      commit('SET_PROGRESO_DESCARGA_QR', null);
      commit('SET_TOTAL_DESCARGA_QR', null);
      commit('SET_DESCARGANDO_QR', false);
      throw e;
    });
  },
};

export const getters = {};
